import { render, staticRenderFns } from "./payModal.vue?vue&type=template&id=47420d88&scoped=true"
import script from "./payModal.vue?vue&type=script&lang=js"
export * from "./payModal.vue?vue&type=script&lang=js"
import style0 from "./payModal.vue?vue&type=style&index=0&id=47420d88&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47420d88",
  null
  
)

export default component.exports